import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { SafeResourceUrl } from '@angular/platform-browser';
import { Usuario } from 'src/app/shared/models/usuario.model';

@Component({
  selector: 'app-login-form-section',
  templateUrl: './login-form-section.component.html',
  styleUrls: ['./login-form-section.component.scss']
})
export class LoginFormSectionComponent implements OnInit {

  @Input()
  bannerUrl: SafeResourceUrl;

  @Input()
  loginLoading = false;

  @Input()
  networkError: string | null = null

  @Output()
  onLogin: EventEmitter<Usuario> = new EventEmitter<Usuario>();

  constructor() { }

  ngOnInit(): void {
  }

  async handleLogin(user: Usuario): Promise<void> {
    this.onLogin.emit(user);
  }

}
